/**
 * Whether any *currently present* question is in edit mode.
 *
 * The editing map is keyed by question field_id and is updated by each
 * DraggableQuestion as it enters/leaves edit mode. When a question is deleted
 * while in edit mode, its DraggableQuestion unmounts without reporting back,
 * leaving a stale `true` entry behind. Scoping the check to the questions that
 * are still present prevents that stale entry from being read as a pending
 * change (which would otherwise trigger the "Unsaved Changes" warning on save).
 */
export const isAnyPresentQuestionEditing = (
  editingMap: Record<string, boolean>,
  presentQuestionIds: string[]
): boolean => {
  return presentQuestionIds.some((id) => editingMap[id] === true)
}
